// Keep ALL pricing logic here so it's consistent everywhere.

// If you want VAT etc later, you can expand this to return { net, vat, gross }.
export const CHECK_PRICES = Object.freeze({
  SIMPLE: { net: 1.2, vat: 0, gross: 1.2, veriff: 0, experian: 1.2 }, // <-- set your real prices
  "PEP & SANCTIONS": { net: 0.6, vat: 0, gross: 0.6, veriff: 0, experian: 0.6 }, // or separate PEP and SANCTIONS if you price them differently
  PEP: { net: 0.6, vat: 0, gross: 0.6, veriff: 0, experian: 0.6 },
  SANCTIONS: { net: 0.6, vat: 0, gross: 0.6, veriff: 0, experian: 0.6 },
  STANDARD: { net: 1.2, vat: 0, gross: 1.2, veriff: 1, experian: 0.2 },
  ENHANCED: { net: 2.4, vat: 0, gross: 2.4, veriff: 1.4, experian: 1 },
  // Add any other custom types you store in Firestore:
  // "DATABASE VERIFICATION": 0,
});

const clean = (v) => String(v ?? "").trim();

export function normaliseCheckType(checkType) {
  const t = clean(checkType);
  const upper = t.toUpperCase();

  // Robust normalisation (handles common variations)
  if (upper.includes("SIMPLE")) return "SIMPLE";
  if (upper.includes("PEP")) return "PEP & SANCTIONS"; // or "PEP" if you price separately
  if (upper.includes("SANCTION")) return "PEP & SANCTIONS";
  if (upper.includes("STANDARD")) return "STANDARD";
  if (upper.includes("ENHANCED")) return "ENHANCED";

  // fallback: try direct match by cleaned string
  return t || "UNKNOWN";
}

export function getCheckPrice(checkType) {
  const key = normaliseCheckType(checkType);
  return Number(CHECK_PRICES[key]?.net ?? 0);
}

export function getCheckPricing(checkType) {
  const key = normaliseCheckType(checkType);
  const pricing = CHECK_PRICES[key] || {};

  return {
    key,
    net: Number(pricing.net ?? 0),
    vat: Number(pricing.vat ?? 0),
    gross: Number(pricing.gross ?? pricing.net ?? 0),
    veriff: Number(pricing.veriff ?? 0),
    experian: Number(pricing.experian ?? 0),
  };
}

// export function formatGBP(amount) {
//     const n = Number(amount ?? 0);
//     return Number.isFinite(n) ? n.toFixed(2) : "0.00";
// }
export function formatGBP(amount) {
  const n = Number(amount ?? 0);
  return new Intl.NumberFormat("en-GB", {
    style: "currency",
    currency: "GBP",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(Number.isFinite(n) ? n : 0);
}
